import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//import { toast } from "react-toastify";


const initialState ={
    supisLoading : false,
    suppliers: [],
    totalSupplier: 0,
    numOfPages: 1,
    page: 1,
    stats: {},
    monthlyApplications: [],
    supiscLoading:false,
    supcstatus:"",
    supcMessage:"",
    supdetails:{},
    supismloading:false,
    supmstatus:"",
    supmmessage:"",
    supSDetails: {},
    supdstatus:"",
    supdmessage:"",
    error:"",
    
};


const supplierSlice = createSlice({
    name: "supplierList",
    initialState,
    reducers:{
        getSupplierPending: (state) => {
            state.supisLoading = true;
        },
        getSupplierSuccess: (state, { payload }) => {
            state.supisLoading = false;
            state.suppliers = payload;
            state.supdetails = payload;
           // state.user="slice userData";
            state.error = '';
        },
        getSupplierFail: (state, { payload }) => {
            state.supisLoading = false;
            state.error = payload;
        },
        createSupplierPending:(state,action) => {
            state.supiscLoading=true;
        },
        createSupplierSuccess:(state,{payload}) => {
            state.supiscLoading=false; //changed
            state.supcstatus="success";
            state.supcMessage="Supplier Created Successfully" //change
        },
        createSupplierFail:(state,{payload}) => {
            state.supiscLoading=false;
            state.supcstatus="fail";
            //console.log('slice '+payload);
            state.supcMessage=payload;
        },
        getSSupplierPending: (state) => {
            state.supisLoading = true;
        },
        getSSupplierSuccess: (state, { payload }) => {
            state.supisLoading = false;
            state.supSDetails=payload;
           
           // state.user="slice userData";
            state.error = '';
        },
        getSSupplierFail: (state, { payload }) => {
            state.supisLoading = false;
            state.error = payload;
        },
        modifySupplierPending:(state,action) => {
            state.supismloading=true;
            state.supmstatus="";
        },
        modifySupplierSuccess:(state,{payload}) => {
            state.supismloading=false;
            state.supmstatus="success";
           
            state.supmmessage="Supplier Successfully Updated";
        },
        modifySupplierFail:(state,{payload}) => {
            state.supismloading=false;
            state.supmstatus="fail";
           // console.log('slice '+payload);
            state.supmmessage="please fill all the fields";
        },
        deleteSupplierPending:(state,action) => {
            state.supisLoading=true;
            state.supdstatus="";
        },
        deleteSupplierSuccess:(state,{payload}) => {
            state.supisLoading=false;
            state.supdstatus="success";
            state.supdmessage="Supplier Successfully Deleted";
        },
        deleteSupplierFail:(state,{payload}) => {
            state.supisLoading=false;
            state.supdstatus="fail";
           // console.log('slice '+payload);
            state.supdmessage=payload;
        },
        reset: () => initialState
    },
});

const { reducer, actions } = supplierSlice;

export const { getSupplierPending, getSupplierSuccess, getSupplierFail,getSSupplierPending, getSSupplierSuccess, getSSupplierFail, 
    createSupplierPending, createSupplierSuccess, createSupplierFail,
    modifySupplierPending,modifySupplierSuccess,modifySupplierFail,
    deleteSupplierPending,deleteSupplierSuccess,deleteSupplierFail  } = actions;

export default reducer;
